import React from "react";
import { Container, Row } from "reactstrap";
import PropTypes from "prop-types";
import { useSidebar } from "context/SidebarContext";
import { useLocation } from "react-router-dom";
import { isWhiteLabel } from "utils/whiteLabel";

function Footer({ default: isDefault, fluid }) {
  const location = useLocation();
  const { isOpen } = useSidebar()

  // console.log("isOpen===",isOpen);
  

  return (
    <footer className={`footer ${
      location.pathname.endsWith("/test") ||
      location.pathname.endsWith("/sectionalTest")
        ? "footer-full"
        : isOpen
        ? "footer-open"
        : "footer-closed"
    } ${isDefault ? " footer-default" : ""}`} 
    // style={{
    //   width: location.pathname.endsWith("/test") ||
    //     location.pathname.endsWith("/sectionalTest") ? "100vw" : (!!isOpen ? "calc(100vw - 260px)" : "calc(100vw - 7%)")
    // }}
    >
      {/* {!isWhiteLabel() && ( */}
        <Container fluid={!!fluid}>
        <Row>
          <div className="credits ml-auto">
            <span className="copyright">
              &copy; {1900 + new Date().getYear()},{" "}{
                isWhiteLabel() ? <>
                <i className="fa fa-heart heart" /> PTEMax. All rights reserved.
                </> : <>
                 made with{" "}
                <i className="fa fa-heart heart" />  by LanguageAcademy
                </>
              }
            </span>
          </div>
        </Row>
      </Container>
      {/* )} */}
    </footer>
  );
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
